import { makeActonCreator } from '../util';

export const UPDATE_LOADING_PROJECT_CAROUSEL =
  'UPDATE_LOADING_PROJECT_CAROUSEL';
export const UPDATE_PROJECTS_TOTAL_COUNT = 'UPDATE_PROJECTS_TOTAL_COUNT';
export const UPDATE_PROJECTS_ITEMS = 'UPDATE_PROJECTS_ITEMS';
export const UPDATE_CURRENT_SOURCE_PAGE = 'UPDATE_CURRENT_SOURCE_PAGE';
export const UPDATE_CURRENT_KEYWORD = 'UPDATE_CURRENT_KEYWORD';

export const updateLoadingProjectCarousel = makeActonCreator(
  UPDATE_LOADING_PROJECT_CAROUSEL,
);
export const updateProjectTotalCount = makeActonCreator(
  UPDATE_PROJECTS_TOTAL_COUNT,
);
export const updateProjectsItems = makeActonCreator(UPDATE_PROJECTS_ITEMS);
export const updateCurrentSourcePage = makeActonCreator(
  UPDATE_CURRENT_SOURCE_PAGE,
);
export const updateCurrentKeyword = makeActonCreator(UPDATE_CURRENT_KEYWORD);
